import { connectOperatorMatrix } from "./socket";

// Una sola conexión real de WebSocket por actividad, compartida entre
// cualquier pantalla que la necesite (Matriz, Log...) — así, navegar de
// una a otra no se interpreta como "salir de la sala" y volver a entrar,
// que antes generaba avisos falsos de conectado/desconectado en el chat.
//
// Cuando la última pantalla que la usaba se cierra, no se corta al
// instante: se espera un margen de gracia por si la siguiente pantalla la
// vuelve a pedir enseguida (que es justo lo que pasa al navegar dentro de
// la propia app). Si nadie la reclama en ese margen, entonces sí se cierra
// de verdad.

const GRACE_MS = 8000;
const pool = new Map(); // activityId -> { socket, refCount, disconnectTimer, listeners, lastJoinResult }

/**
 * Reserva la conexión compartida de una actividad. `onJoined` se llama
 * cada vez que hay un resultado nuevo de join_activity (al conectar por
 * primera vez, y en cada reconexión) — y también de inmediato, si ya
 * había uno guardado de antes, para no dejar a la pantalla esperando.
 *
 * Devuelve { socket, release } — hay que llamar a release() al desmontar.
 */
export function acquireActivitySocket(activityId, token, onJoined) {
  let entry = pool.get(activityId);

  if (!entry) {
    const socket = connectOperatorMatrix(token);
    entry = { socket, refCount: 0, disconnectTimer: null, listeners: new Set(), lastJoinResult: null };
    pool.set(activityId, entry);

    socket.on("connect", () => {
      socket.emit("join_activity", { activityId }, (res) => {
        entry.lastJoinResult = res;
        entry.listeners.forEach((fn) => fn(res));
      });
    });
  }

  entry.refCount++;
  if (entry.disconnectTimer) {
    clearTimeout(entry.disconnectTimer);
    entry.disconnectTimer = null;
  }
  entry.listeners.add(onJoined);

  // Siempre se pide un estado fresco al adquirir — aunque la conexión ya
  // estuviera viva de antes (por ejemplo, al volver de Log a Matriz) — para
  // no quedarse con la foto de cuando se abrió la conexión por primera vez.
  // El servidor solo anuncia "conectado" la primera vez de verdad, así que
  // repetir esto no genera ruido en el chat.
  if (entry.socket.connected) {
    entry.socket.emit("join_activity", { activityId }, (res) => {
      entry.lastJoinResult = res;
      onJoined(res);
    });
  }

  const release = () => {
    entry.listeners.delete(onJoined);
    entry.refCount--;
    if (entry.refCount <= 0) {
      entry.disconnectTimer = setTimeout(() => {
        entry.socket.disconnect();
        pool.delete(activityId);
      }, GRACE_MS);
    }
  };

  return { socket: entry.socket, release };
}
